import Swiper, { Lazy, Scrollbar } from 'swiper';
import { debounce } from '@github/mini-throttle';
export const init = async function() {
    Swiper.use([
        Lazy,
        Scrollbar
    ]);
    let swiper;
    const createSlider = ()=>{
        return new Swiper('.js-swiper-color-swatches', {
            slidesPerView: 'auto',
            spaceBetween: 8,
            freeMode: true,
            autoHeight: false,
            modules: [
                Scrollbar
            ],
            watchSlidesProgress: true,
            direction: 'horizontal',
            scrollbar: {
                el: '.js-swiper-color-swatches .swiper-scrollbar',
                draggable: true,
                hide: false
            },
            breakpoints: {
                1024: {
                    enabled: false,
                    scrollbar: {
                        el: '.js-swiper-color-swatches .swiper-scrollbar',
                        draggable: false,
                        hide: true
                    }
                },
                0: {
                    enabled: true,
                    scrollbar: {
                        el: '.js-swiper-color-swatches .swiper-scrollbar',
                        draggable: true,
                        hide: false
                    }
                }
            }
        });
    };
    // When multiple sliders are present the swiper object will be an array of
    // swiper instances. This is it, from the swiper library v7.4.1.
    // We should consider updating swiper to the latest version
    // to take advantage of the newest features and bug fixes
    const debouncedResize = debounce(()=>{
        if (Array.isArray(swiper)) {
            swiper.forEach((swiperInstance)=>{
                if (window.innerWidth >= 1024) {
                    swiperInstance.destroy(true, true);
                } else {
                    swiperInstance = createSlider();
                }
            });
        } else {
            if (window.innerWidth >= 1024 && swiper) {
                swiper.destroy(true, true);
            } else {
                swiper = createSlider();
            }
        }
    }, 100);
    if (window.innerWidth <= 1024) {
        swiper = createSlider();
    }
    window.addEventListener('resize', debouncedResize);
};
